// extracted by mini-css-extract-plugin
module.exports = {"error":"SessionTypeNameEditor_error__2FXgF"};